import { Children, forwardRef, isValidElement, type ReactNode } from 'react';

import { VirtualList, type VirtualListHandle } from '@ui/components/virtualization/VirtualList';

const LISTBOX_MAX_HEIGHT = 336;
export const VIRTUAL_THRESHOLD = 0;

interface VirtualListboxProps {
  children: ReactNode;
  className?: string;
}

export const VirtualListbox = forwardRef<VirtualListHandle, VirtualListboxProps>(({ children, className }, ref) => {
  const items = Children.toArray(children).filter(isValidElement);
  return (
    <VirtualList
      ref={ref}
      sizing="content"
      maxHeight={LISTBOX_MAX_HEIGHT}
      count={items.length}
      getItemKey={(index) => items[index].key ?? index}
      renderItem={(index) => items[index]}
      className={className}
    />
  );
});
VirtualListbox.displayName = 'VirtualListbox';
